import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Selectors from '../selectors';
import Actions from '../action';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import CommissionSummaryPresentational from './commission-summary-presentational';
import { setStartDate } from '@helpers';
import { datePickerValues, dateFormats } from '@constants';
import { useHistory } from 'react-router';

const CommissionSummaryFunctional = ({ userDetails, commissionSummaryLoading, commissionSummaryData, getCommissionSummary }) => {
	const [state, setState] = useState({
		modalOpened: false,
		// fromDate: moment(setStartDate(datePickerValues.LAST)).format(dateFormats.MM_DD_YYYY),
		// toDate: moment(new Date()).format(dateFormats.MM_DD_YYYY),
		fromDate: '09/09/2019',
		toDate: '09/09/2020',
	});

	const history = useHistory();

	useEffect(() => {
		const { fromDate, toDate } = state;
		getCommissionSummary({ fromDate, toDate }, history);
	}, []);

	const handleSetState = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};

	const handleModal = (modalOpened) => {
		setState({
			...state,
			modalOpened,
		});
	};

	const dataRangeChanged = (value) => {
		// let request = {};
		// if (value && value[0] && value[0] !== '') {
		// 	setState({
		// 		...state,
		// 		fromDate: value[0],
		// 	});
		// 	request.fromDate = value[0];
		// } else {
		// 	request.fromDate = state.fromDate;
		// }
		// if (value && value[1] && value[1] !== '') {
		// 	setState({
		// 		...state,
		// 		toDate: value[1],
		// 	});
		// 	request.toDate = value[1];
		// } else {
		// 	request.toDate = state.toDate;
		// }
		setState({
			...state,
			fromDate: value[0],
			toDate: value[1],
		});
	};

	const createSummary = () => {
		const { fromDate, toDate } = state;
		setState({
			...state,
			modalOpened: false,
		});
		getCommissionSummary({ fromDate, toDate }, history);
	};

	return (
		<CommissionSummaryPresentational
			commissionSummaryLoading={commissionSummaryLoading}
			commissionSummaryData={commissionSummaryData}
			handleSetState={handleSetState}
			state={state}
			userDetails={userDetails}
			handleModal={handleModal}
			dataRangeChanged={dataRangeChanged}
			createSummary={createSummary}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: SelectorsApp.userDetails(state),
		commissionSummaryLoading: Selectors.commissionSummaryLoading(state),
		commissionSummaryData: Selectors.commissionSummaryData(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getCommissionSummary: (request, history) => dispatch(Actions.creators.getCommissionSummary(request, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(CommissionSummaryFunctional);

export default Connected;
